export default function makeImage(images: string[]): string {
  return images[0] ?? "";
}
